import { Component, Input, OnInit } from '@angular/core';
import { DAO } from '../../modal/DAO';
import { Router, NavigationEnd } from '@angular/router';
import { ServiceLayer } from '../../services/serviceLayer';
import { AuthenticationService } from '../../services/authentication.service';
import {jwtDecode} from 'jwt-decode';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() notification:any;
  public currentPath: string = '';
  public isBFMInternal:boolean = false;
  constructor(public dao:DAO,public router:Router,
    public serviceLayer:ServiceLayer,
    private authenticationService: AuthenticationService) { }

    async ngOnInit() {
      this.currentPath = window.location.pathname;
  
      if (this.dao.loginUserDetail?.isInternal === false && !this.dao.loginUserDetail?.agencies && this.currentPath !== '/xps/unauthenticated') {
        window.location.href = "/xps/unauthenticated";
      }
  
      if (this.dao.loginUserDetail?.isInternal && this.dao.loginUserDetail?.email.includes("@berkleymarine.com")) {
        this.isBFMInternal = true;
      }
  
      if (this.notification?.type === "SITEDOWN") {
        this.router.navigate(['/xps/maintenance']);
      }
  
     await this.getToken();
    }

    async getToken() {
     this.authenticationService.idToken$.subscribe(token => {
          if (token) {
              try {
                  const decodedToken: any = jwtDecode(token);
                  this.dao.loginUserDetail = {
                      ...this.dao.loginUserDetail,
                      email: decodedToken?.email || this.dao.loginUserDetail?.email || null,
                      given_name: decodedToken?.name || this.dao.loginUserDetail?.given_name || null,
                      family_name: decodedToken?.family_name || this.dao.loginUserDetail?.family_name || null,
                      isinternal: decodedToken?.sub.startsWith("auth0|") ? false : this.dao.loginUserDetail?.isinternal || true
                  };
                  window.localStorage.setItem('loginUserDetails', JSON.stringify(this.dao.loginUserDetail));
                  this.getAccessToken();
              } catch (error) {
                  console.error('Error decoding token:', error);
              }
          }
      });
  }

  async getAccessToken() {
    this.authenticationService.accessToken$.subscribe(token => {
      if (token) {
          try {
              const decodedToken: any = jwtDecode(token);

              const metadata = decodedToken?.["app-metadata"] || {};
              const companyList = metadata?.company || metadata?.Company || [];
              const isInternal = decodedToken?.sub?.startsWith("auth0|") ? false : true;

              this.dao.loginUserDetail = {
                  ...this.dao.loginUserDetail,
                  userCompanyGroup: companyList.includes("BFM") ? "BFM" : this.dao.loginUserDetail?.userCompanyGroup,
                  userCompany: companyList.includes("BFM") ? "BFM" : this.dao.loginUserDetail?.userCompany,
                  isinternal: isInternal
              };
              window.localStorage.setItem('loginUserDetails', JSON.stringify(this.dao.loginUserDetail));
          } catch (error) {
              console.error('Error decoding token:', error);
          }
      }
  });
  }

    // getToken() {
    //   this.authenticationService.accessToken$.subscribe(token => {
    //     console.log('Received Token:', token); // Check if this logs the token correctly
    //     if (token) {
    //       try {
    //         const decodedToken: any = jwtDecode(token);
    //         if (!this.dao.loginUserDetail) {
    //           this.dao.loginUserDetail = {}; // Initialize loginUserDetail if it is null or undefined
    //         }
    //         console.log('Decoded Token Details:', JSON.stringify(decodedToken));
    //         // Update dao.loginUserDetail with decodedToken details
    //         this.dao.loginUserDetail.email = decodedToken?.email || null;
    //         this.dao.loginUserDetail.given_name = decodedToken?.name || null;
    //         this.dao.loginUserDetail.family_name = decodedToken?.family_name || null;
    //         if (decodedToken?.company?.includes("BFM")) {
    //           this.dao.loginUserDetail.userCompanyGroup = "BFM";
    //           this.dao.loginUserDetail.userCompany = "BFM";
    //         }
    //         // Check if the user is internal or external
    //         if (decodedToken?.sub.startsWith("auth0|")) {
    //           this.dao.loginUserDetail.isinternal = false;
    //         } else {
    //           this.dao.loginUserDetail.isinternal = true;
    //         }
    //         window.localStorage.setItem('loginUserDetails', JSON.stringify(this.dao.loginUserDetail));
    //       } catch (error) {
    //         console.error('Error decoding token:', error);
    //       }
    //     }
    //   });
    // }
    

  policy(policytype) {
    if(policytype != undefined && policytype == 'Cancel My Policy') {
      window.localStorage.setItem("policyType", "Cancel My Policy");
    }
    else if(policytype != undefined && policytype == 'Manage a Policy') {
      window.localStorage.setItem("policyType", "Manage a Policy");
    }
    window.localStorage.setItem("currentPolicy","");
  }
  public async logout(){
    location.href = "https://www.berkleymarine.com/agent-central/";
    // await this.authenticationService['salteAuth']['logoutWithRedirect']("");
  }
}
